import * as Pages from '../../pages';

import { VIEW_TYPES } from '../../constants/viewTypes';
import { ROUTE_ACCESS_TYPE } from '../../constants/routeAccessType';

export const assistantRoutes = [
    {
        path: '/assistant',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.AssistantPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
    {
        path: '/assistant/chat/:chatThreadId',
        indexPath: '/assistant',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.AssistantPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
];
